import { Box } from "@chakra-ui/react";
import React from "react";
import useStore from "../../../utils/store";
import Modal from "../../podcasts/Modal";


const Buttons2 = ({ item, update, deletePodcast, episeries, subcategories }) => {
  const user = useStore((state) => state.user);
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: ".5rem",
        marginTop: "1rem",
      }}
    >
      {user?.updateMovie && (
        <Modal
          title={"Move To Videos"}
          update={item}
          color="green"
          save={update}
          episeries={episeries}
          categories={subcategories}
        />
      )}
    </Box>
  );
};

export default Buttons2;